import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCompassSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M3 6.5C3 4.567 4.567 3 6.5 3H17.5C19.433 3 21 4.567 21 6.5V17.5C21 19.433 19.433 21 17.5 21H6.5C4.567 21 3 19.433 3 17.5V6.5ZM14.5901 8.48905C15.1499 8.33635 15.6637 8.85009 15.511 9.40996L14.3916 13.5145C14.2751 13.9415 13.9415 14.2751 13.5145 14.3916L9.40996 15.511C8.85008 15.6637 8.33635 15.1499 8.48905 14.5901L9.60847 10.4855C9.72493 10.0585 10.0585 9.72492 10.4855 9.60847L14.5901 8.48905Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassSquare;
